import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./utils.js";
export function Card({ className, ...props }) {
    return (_jsx("section", { className: cn("rounded-xl border border-stone-200 bg-surface text-stone-950", className), ...props }));
}
export function CardHeader({ className, ...props }) {
    return (_jsx("header", { className: cn("space-y-1.5 p-5 pb-3", className), ...props }));
}
export function CardTitle({ className, ...props }) {
    return (_jsx("h2", { className: cn("text-base font-bold tracking-[-0.015em]", className), ...props }));
}
export function CardDescription({ className, ...props }) {
    return (_jsx("p", { className: cn("text-sm leading-5 text-stone-500", className), ...props }));
}
export function CardContent({ className, ...props }) {
    return _jsx("div", { className: cn("p-5 pt-2", className), ...props });
}
